import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportingService {

  constructor(
    private _http: HttpClient
  ) { }

  public downloadReport(params:any, practiceId:number): Observable<any>{
    return this._http.post(environment.apiEndpoint+'/api/reporting/download/'+practiceId, {params:params}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public deleteCSV(practiceId:number): Observable<any>{
    return this._http.delete(environment.apiEndpoint+'/api/reporting/'+practiceId).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public getUserReport(practiceId:number, userId:number, startdate, closedate):Observable<any>{
    return this._http.get(environment.apiEndpoint+`/api/reporting/${practiceId}/${userId}/${startdate}/${closedate}`).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }
}
